import { CheckCircle2 } from "lucide-react";
import { Button } from "../custom_ui/button.tsx";

interface AboutSectionProps {
  content?: {
    about_features?: string[];
    about_title?: string;
    about_description_1?: string;
    about_description_2?: string;
  };
}

const defaultFeatures: string[] = [
  "Social Media Management",
  "YouTube Adverts & Views",
  "Search Engine Optimization",
  "Website Development",
  "Content Creation",
  "Digital Distribution",
];

export function AboutSection({ content }: AboutSectionProps) {
  const features = content?.about_features && content.about_features.length > 0 
    ? content.about_features 
    : defaultFeatures;

  return (
    <section id="about" className="py-24 bg-secondary/20">
      <div className="container mx-auto px-4">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <p className="text-primary font-medium tracking-[0.2em] uppercase mb-4">
              About Us
            </p>
            <h2 className="font-display text-4xl md:text-5xl lg:text-6xl text-foreground mb-6">
              {content?.about_title || "WE ARE BAAJ MEDIA"}
            </h2>
            <p className="text-muted-foreground text-lg leading-relaxed mb-6">
              {content?.about_description_1 || "Baaj Media is a leading digital marketing company in India, established in 2017. We specialize in creating impactful digital campaigns that elevate brands and drive real results."}
            </p>
            <p className="text-muted-foreground leading-relaxed mb-8">
              {content?.about_description_2 || "With over 7 years of experience, we've helped hundreds of clients achieve their digital goals through innovative strategies and creative excellence. Our team combines industry expertise with cutting-edge technology to deliver outstanding results."}
            </p>

            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10">
              {features.map((feature: string) => (
                <div key={feature} className="flex items-center gap-3">
                  <CheckCircle2 className="text-primary shrink-0" size={20} />
                  <span className="text-foreground font-medium">{feature}</span>
                </div>
              ))}
            </div>

            <Button variant="hero" size="xl">
              Learn More About Us
            </Button>
          </div>

          {/* Right Content - Decorative */}
          <div className="relative hidden lg:block">
            <div className="aspect-square relative">
              {/* Background shapes */}
              <div className="absolute top-10 right-10 w-72 h-72 rounded-full bg-gradient-gold opacity-20 blur-3xl" />
              <div className="absolute bottom-10 left-10 w-56 h-56 rounded-full bg-primary/30 blur-2xl" />
              
              {/* Main card */}
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="w-80 h-80 rounded-3xl bg-gradient-card border border-border/50 shadow-elevated p-8 flex flex-col justify-center items-center text-center transform rotate-3 hover:rotate-0 transition-transform duration-500">
                  <div className="font-display text-8xl text-gradient-gold mb-4">
                    7+
                  </div>
                  <p className="text-foreground text-xl font-medium mb-2">
                    Years of Excellence
                  </p>
                  <p className="text-muted-foreground">
                    Delivering digital success since 2017
                  </p>
                </div>
              </div>

              {/* Floating elements */}
              <div className="absolute top-20 left-0 w-24 h-24 rounded-xl bg-gradient-gold shadow-gold flex items-center justify-center animate-float">
                <span className="font-display text-3xl text-primary-foreground">450+</span>
              </div>
              <div className="absolute bottom-20 right-0 w-20 h-20 rounded-full bg-secondary border border-border flex items-center justify-center animate-float" style={{ animationDelay: "0.5s" }}>
                <span className="font-display text-2xl text-primary">160+</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
